import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

import styles from '../styles/landing.module.css'
import LandingProducts from '../components/LandingProducts';
import getImgUrl from "../helper/getImgUrl";
import { getLandingProducts } from '../lib/shopify';

const LANDING_DATA = {
    maintitle: "The Wetland Shop",
    intro: "Handcrafted custom wood furniture inspired by the natural world. Each piece is made to order from sustainably sourced hardwoods, built to last a lifetime.",
    mainphoto: "/img/mainphoto-1758578007231-210425894.jpg",
    ctaphoto: "/img/snapphoto-1758578007242-770406984.jpg",
};

const STATS = [
    { value: "100%", label: "Custom Made" },
    { value: "10+", label: "Years of Craft" },
    { value: "500+", label: "Pieces Built" },
    { value: "Est.", label: "2015" },
];

const STEPS = [
    {
        number: "01",
        title: "Consult",
        desc: "Tell us what you need. We'll work with you on dimensions, wood species, and finish to create a design that fits your space perfectly.",
    },
    {
        number: "02",
        title: "Craft",
        desc: "Every piece is built by hand in our Ontario workshop using sustainably sourced hardwoods. No shortcuts, no flat-pack.",
    },
    {
        number: "03",
        title: "Deliver",
        desc: "We ship across Canada with white-glove delivery. Your piece arrives protected, assembled, and ready to place.",
    },
];

const Landing = () => {
    const [productData, setProductData] = useState([]);

    const fetchProducts = async () => {
        try {
            const data = await getLandingProducts();
            setProductData(data);
        } catch (error) {
            console.error('Error fetching products', error);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    return (
        <div className={styles.landing}>

            {/* Hero */}
            <div className={styles.top_panel}>
                <div className={styles.title}>
                    <div className={styles.mainTitle}>
                        <h1>{LANDING_DATA.maintitle}</h1>
                    </div>
                    <div className={styles.divider}></div>
                    <div className={styles.intro}>
                        <p>{LANDING_DATA.intro}</p>
                    </div>
                </div>
                <div className={styles.mainPhoto}>
                    <img src={getImgUrl(LANDING_DATA.mainphoto)} alt=""/>
                </div>
            </div>

            {/* Most Popular Products */}
            <div className={styles.section2}>
                <div className={styles.textsnip}>
                    <p>OUR MOST POPULAR PRODUCTS</p>
                </div>
            </div>
            <div className={styles.section3}>
                {productData.map(product => <LandingProducts product={product} key={product.id}/>)}
            </div>

            {/* Stats Bar */}
            <div className={styles.statsBar}>
                {STATS.map((stat, idx) => (
                    <div key={idx} className={styles.statItem}>
                        <span className={styles.statValue}>{stat.value}</span>
                        <span className={styles.statLabel}>{stat.label}</span>
                    </div>
                ))}
            </div>

            {/* How It Works */}
            <div className={styles.howItWorks}>
                <div className={styles.howTitle}>
                    <p>THE PROCESS</p>
                    <h2>How It Works</h2>
                </div>
                <div className={styles.steps}>
                    {STEPS.map((step) => (
                        <div key={step.number} className={styles.step}>
                            <span className={styles.stepNumber}>{step.number}</span>
                            <h3>{step.title}</h3>
                            <p>{step.desc}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* CTA Banner */}
            <div
                className={styles.ctaBanner}
                style={{ backgroundImage: `url(${getImgUrl(LANDING_DATA.ctaphoto)})` }}
            >
                <div className={styles.ctaOverlay}>
                    <h2>Every piece, made for you.</h2>
                    <p>Fully custom. Sustainably sourced. Built to last a lifetime.</p>
                    <NavLink to="/products" className={styles.ctaLink}>
                        <button className={styles.ctaBtn}>Shop All Products →</button>
                    </NavLink>
                </div>
            </div>

            {/* Recognition */}
            <div className={styles.section4}>
                <div className={styles.border}>
                    <div className={styles.border1}>
                        <p>customers</p>
                    </div>
                    <div className={styles.border2}>
                        <p>Architecture & Interior</p>
                    </div>
                    <div className={styles.border3}>
                        <p>builder</p>
                    </div>
                </div>
                <div className={styles.recognition}>
                    <div className={styles.recTitle}>
                        <h1>Recognition</h1>
                    </div>
                    <div className={styles.feedBack}>
                        <div>
                            <h3>"Flawless execution is nothing without an idea to connect the dots. And while awards aren't everything, they do demonstrate the high level of quality we see as the 'Nightjar Standard' - that extra level of polish and finesse that tips a project from great to absolutely world-class. And across the world is where our work has been getting noticed."</h3>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Landing
